import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M8.854 14.646a.5003.5003 0 0 0-.707 0l-3.146 3.146V.499c0-.276-.224-.5-.5-.5s-.5.224-.5.5v17.293L.855 14.646c-.195-.195-.512-.195-.707 0s-.195.512 0 .707l4 4c.098.098.226.146.354.146s.256-.049.354-.146l4-4a.5003.5003 0 0 0 0-.707zM19.96 7.303l-3-7a.5005.5005 0 0 0-.92 0l-3 7a.5004.5004 0 1 0 .92.394L15.116 5h2.769l1.156 2.697a.4993.4993 0 0 0 .657.262.5012.5012 0 0 0 .263-.657zM15.544 4l.956-2.231L17.456 4h-1.912zM18.5 20h-4c-.178 0-.343-.095-.432-.249s-.09-.344-.002-.499L17.639 13h-3.138c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h4c.178 0 .343.095.432.249s.09.344.002.499L15.362 19H18.5c.276 0 .5.224.5.5s-.224.5-.5.5z',
  ],
  height: 20,
  width: 20,
});
